module.exports = __webpack_public_path__ + "static/logo-12748c81039b1d3f91d9cb52a79b1fd2.svg";